// map component themes to text themes
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();export const themeMapping = {
    Small: {
        headline: {
            baseTheme: 'displayXSmall',
            themes: {
                large: 'displaySmall',
            },
        },
        copy: {
            baseTheme: 'bodySmall',
            themes: {
                large: 'bodyMedium',
            },
        },
    },
    Medium: {
        headline: {
            baseTheme: 'displayXSmall',
            themes: {
                large: 'displayMedium',
            },
        },
        copy: {
            baseTheme: 'bodySmall',
            themes: {
                large: 'bodyMedium',
            },
        },
    },
    Large: {
        headline: {
            baseTheme: 'displaySmall',
            themes: {
                large: 'displayLarge',
            },
        },
        copy: {
            baseTheme: 'bodyMedium',
            themes: {
                large: 'bodyLarge',
            },
        },
    },
    'X-Large': {
        headline: {
            baseTheme: 'displayMedium',
            themes: {
                large: 'displayXLarge',
            },
        },
        copy: {
            baseTheme: 'bodyMedium',
            themes: {
                large: 'bodyLarge',
            },
        },
    },
    'XX-Large': {
        headline: {
            baseTheme: 'displayMedium',
            themes: {
                large: 'displayXXLarge',
            },
        },
        copy: {
            baseTheme: 'bodyMedium',
            themes: {
                large: 'bodyLarge',
            },
        },
    },
};
